// extracted by mini-css-extract-plugin
export var formDisclaimer = "reportFeedback-module--formDisclaimer--2Ck+h";
export var modal = "reportFeedback-module--modal--5eRn6";
export var title = "reportFeedback-module--title--iQgIt";